<template>
  <el-upload
      :show-file-list="showFileList"
      :auth-index="authIndex"
      action=""
      :multiple="multiple"
      :http-request="getVoucher"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :on-change="handleChange"
      :on-preview="filePreview"
      :on-remove="fileRemove"
  >
    <el-button :disabled="disabled" size="mini" type="primary"><i>上传附件</i><i class="el-icon-upload el-icon--right"></i></el-button>
  </el-upload>
</template>

<script>
  import axios from "axios";
  export default {
    props: {
      // 批量上传
      multiple: {
        type: Boolean,
        default: false,
      },
      // 模块权限
      authIndex: {
        type: Number,
        required: true,
      },
      // 文件列表
      file: {
        type: Array,
        default: () => {
          return [];
        },
      },
      showFileList: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        fileList: [],
      };
    },

    watch: {
      file: {
        handler(val) {
          this.fileList = val;
        },
      },
    },

    methods: {
      // 获取文件上传的url
      getVoucher(file) {
        this.$http.get("basic", `files/getUploadUrl?filename=${encodeURIComponent(file.file.name)}&authIndex=${this.authIndex}`).then((res) => {
          if (res.success) {
            axios({
              method: "PUT",
              headers: res.data.headers,
              url: res.data.url,
              data: file.file,
            }).then(() => {
              this.fileList.forEach((item) => {
                if (item.name == file.file.name) {
                  item.key = res.data.key;
                }
              });
              this.$emit("upload-success", this.fileList);
            });
          }
        });
      },

      // 文件预览
      filePreview(file) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(file.key)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      // 文件列表
      handleChange(file, fileList) {
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }
        this.fileList = fileList;
        this.$emit("fileChange", this.fileList);
      },

      fileRemove(file, fileList) {
        this.$emit("removeFile", fileList);
      },

      beforeUpload(file,fileList){
        this.$emit("beforeUpload", fileList);
      },
    },
  };
</script>
